module.exports = __webpack_public_path__ + "img/herz.4dffe6a0.svg";